addEventListener("DOMContentLoaded", _=> {
    if(!window.locIcon) return;
    let list = locIcon.nextElementSibling.nextElementSibling;
    list.onmouseleave = _=> locIcon.checked = false;

    locIcon.onclick = _=> {
        if(list.offsetLeft + list.offsetWidth - 16 > document.body.offsetWidth) {
            list.style.right = "calc(var(--space) / 2)";
        }
        else list.style.removeProperty("right");
    }

});